define('viewmodels/Weightings_Thresholds/InherentWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils, ObjGeneralSettings) {
        var title = 'InherentWeightings';

        var IWViewModel = {
            activate: activate,
            title: title,
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            GetSurveyCategoryTabs: GetSurveyCategoryTabs,
            SurveyCategoryList: ko.observableArray([]),
            AssessmentTypeList: ko.observableArray([]),
            SelectedAssessmentId: ko.observable(),
            AssessmentType: ko.observable(),
            AssessmentTypeId: ko.observable(),
            ScreenName: ko.observable(),
            SurveyCategoryList: ko.observableArray([]),
            SelectedSurveyComponentId: ko.observable(),
            RiskAreaTypeList: ko.observableArray([]),

            countEntry: ko.observable(0),
            RiskAreaTabClicked: ko.observable(),
            WeightingsType: ko.observable(), //this specifies the type of the weightings. RA:Area|OA:Overall|BUL:business unit level|BULOverall :business unit level
            RAName: ko.observable(),
            ThemeId: ko.observable(),
            ClickedRiskAreaName: ko.observable(),
            RiskFactorList: ko.observableArray(),
            ClickedRiskAreaType: ko.observable(),
            hasSubArea: ko.observable(),
            Parent_Id: ko.observable(),
            Type: ko.observable(),
            copyDataButtonClicked: ko.observable(false),
            SurveyCategoryTabClickIW: SurveyCategoryTabClickIW,
            SurveyTypeClicked: ko.observable(),
            SurveyCategoryID: ko.observable(),
            GetRiskLevelDetails: GetRiskLevelDetails,
            ShowDetailsTab: ko.observable(),
            BusinessLevelList: ko.observable([]),
            RiskAreaList: ko.observableArray(),
            RiskLevelTabClick: RiskLevelTabClick,
            AreaLeveljstree: ko.observableArray([]),
            nodeClickEvent: nodeClickEvent,
            InitiateLevelTree: InitiateLevelTree,
            EditableBusinessunitTotal: ko.observable(0),
            ToggleNavigationMenu1: ToggleNavigationMenu1,
            ToggleNavigationMenu2: ToggleNavigationMenu2,
            CollapseAllTreeView: CollapseAllTreeView,
            selectedAreaId: ko.observable(),
            weightingsTableTitle: ko.observable(),
            IsDeadNode: ko.observable(0),
            GetInherentWeights: GetInherentWeights,
            BusinessUnits: ko.observableArray([]),
            AreasOrQuestions: ko.observableArray([]),
            inherentWeight: ko.observableArray([]),
            totalWeightList: ko.observableArray([]),
            EditableBusinessunitTotal: ko.observable(0),
            EditableBusinessUnitName: ko.observable(),
            setSelectedBusinessUnit: setSelectedBusinessUnit,
            EditBUWeights: EditBUWeights,
            SelectBusinessUnit: ko.observable(),

            AutoPopulateWeights: AutoPopulateWeights,
            TaxonomyLevels: ko.observableArray([]),
            PopulateWeights: PopulateWeights,
            selectedOrgLevelAP: ko.observable(),
            selectedTaxonomyLevel: ko.observable(),
            selectedBULevel: ko.observable(),
            IsLowestLevelSelected: ko.observable(false),
            GetQuestionTypes: GetQuestionTypes,
            QuestionTypes: ko.observableArray([]),
            saveWeights: saveWeights,
            checkCopyOver: checkCopyOver,
            WeightingsList: ko.observableArray([]),
            downloadWeightings: downloadWeightings,
            RefreshWeights: RefreshWeights,
            BulkDownloadWeights: BulkDownloadWeights,
            BulkUploadWeights: BulkUploadWeights,
            downloadBulkUploadExcel: downloadBulkUploadExcel,
            SelectedOrgLevel: ko.observable(),
            GetTaxonomyLevels: GetTaxonomyLevels,
            TaxonomyLevelChanged: TaxonomyLevelChanged,
            BulkuploadWeightingsDocument: BulkuploadWeightingsDocument,
            ConfigurePrecision: ConfigurePrecision,
            setPrecisionValues: setPrecisionValues,
            decimalLimit: ko.observable(5),
            decimalOptions: ko.observableArray(['2', '3', '4', '5']),
            uploadDownloadWeightings: uploadDownloadWeightings,
            uploadWeightingsDocument: uploadWeightingsDocument,
            screenType: ko.observable(),
            uploadselectedOrganizationLevel: ko.observable(),
            ClickedBulevel: ko.observable(),
            isHeaderQuestion: ko.observable(0),
            ControlsAccess: ko.observable(false),
            totalValidityFlag: ko.observable(1),
            hasChildNodes: ko.observable(false),
            selectedNodeType: ko.observable(),
            showGlobalConfigurationFlag: ko.observable(false),
            isGlobalFlag: ko.observable(false),
            isAdvancedSettings: ko.observable(false),
            isAdvancedSettingsDUP: ko.observable(false),
            ToggleSettingsMode: ToggleSettingsMode,
            SaveGlobalFlag: ko.observable(false),
            TaxonomyLevelChildrenModel: TaxonomyLevelChildrenModel,
            TaxonomyLevelChildren: ko.observableArray([]),
            selectedTaxonomyLevelChild: ko.observable(),
            selectedTaxonomyLevelChildName: ko.observable(),
            SelectedTaxonomyLevelChildChanged: SelectedTaxonomyLevelChildChanged,
            applyGlobalWeights: applyGlobalWeights,
            AdvanceWeightingslevelSelection: AdvanceWeightingslevelSelection,
            TaxonomyLevelSelectDisable: ko.observable(false),
            ModeSettingsClick: ModeSettingsClick,
            LocaleCheckFlag: ko.observable(false),
            UpperDecimalLimit: ko.observable(100.00000),
            LowerDecimalLimit: ko.observable(0.00000),
        };

        return IWViewModel;

       //#region ----Run Time Events----

        function activate() {
            try {
                var Id = IWViewModel.appsecurity.getParameterByName('atype');
                IWViewModel.AssessmentTypeId(Id);
                IWViewModel.appsecurity.GetAssessmentNames().then(() => {
                    IWViewModel.AssessmentType(IWViewModel.appsecurity.GetAssessmentName(IWViewModel.AssessmentTypeId()));
                    IWViewModel.ScreenName(IWViewModel.AssessmentType() + ' ' + ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightings') == -1) ? 'Inherent Weightings' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightings')].Name()));
                });

                if (IWViewModel.ObjGeneralSettings === undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((IWViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && IWViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    IWViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {

                        if (IWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() == null || IWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            IWViewModel.LocaleCheckFlag(false);
                        else
                            IWViewModel.LocaleCheckFlag(true);
                    });
                }
                else {
                    if (IWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() == null || IWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        IWViewModel.LocaleCheckFlag(false);
                    else
                        IWViewModel.LocaleCheckFlag(true);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: activate() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                var Id = IWViewModel.appsecurity.getParameterByName('atype');
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: detached() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                $('.content').hide();
                $('#mainLoader').show();

                GetSurveyCategoryTabs();
                IWViewModel.EditableBusinessUnitName("Editable BusinessUnit name");
                //GetQuestionTypes();
                if (appsecurity.isConfigurationFreeze() === undefined) {
                    appsecurity.GetConfigurationFreezeFlag().then(function () {
                        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                            IWViewModel.ControlsAccess(true);
                        }
                        else {
                            IWViewModel.ControlsAccess(false);
                        }
                    });
                }
                else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                    IWViewModel.ControlsAccess(true);
                }
                else {
                    IWViewModel.ControlsAccess(false);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: attached() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

       //#region ----Taxonomy Methods----

        function TaxonomyLevelChanged() {

            for (var i = 0; i < IWViewModel.TaxonomyLevels().length; i++) {
                if (IWViewModel.TaxonomyLevels()[i].LevelId() == IWViewModel.selectedTaxonomyLevel()) {
                    if (IWViewModel.TaxonomyLevels()[i].showGlobalFlag() == 1) {
                        IWViewModel.showGlobalConfigurationFlag(true);
                    }
                    else {
                        IWViewModel.showGlobalConfigurationFlag(false);
                    }

                    if (IWViewModel.TaxonomyLevels()[i].isMaxLevel() == 1) {
                        IWViewModel.IsLowestLevelSelected(true);
                        GetQuestionTypes();
                    }
                    else {
                        IWViewModel.IsLowestLevelSelected(false);
                    }

                    break;
                }
            }
        }

        function SelectedTaxonomyLevelChildChanged() {

            for (var i = 0; i < IWViewModel.TaxonomyLevelChildren().length; i++) {
                if (IWViewModel.TaxonomyLevelChildren()[i].EALId() == IWViewModel.selectedTaxonomyLevelChild()) {
                    IWViewModel.selectedTaxonomyLevelChildName(IWViewModel.TaxonomyLevelChildren()[i].EALName());
                    break;
                }
            }
        }

        //#endregion

       //#region ----Get Methods----

        function GetInherentWeights() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/GetInherentWeights",
                    type: "GET",
                    headers: headers,
                    data: { "AssessmentType": IWViewModel.AssessmentTypeId(), "SurveyCategoryId": IWViewModel.SurveyCategoryID().toString(), "AreaId": IWViewModel.selectedAreaId(), "OrgLevel": IWViewModel.SelectedOrgLevel(), "NodeType": IWViewModel.selectedNodeType() }
                })
                    .success((jsonResult, success) => {
                        try {

                            $('#loadingMainInherentDiv').hide();
                            $('#WeightingsTableDiv').show();
                            if (jsonResult !== null) {
                                if (jsonResult.Incident_Description != null) {
                                    logger.logError(jsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                                }
                                else {
                                    IWViewModel.BusinessUnits([]);
                                    IWViewModel.AreasOrQuestions([]);
                                    IWViewModel.inherentWeight([]);

                                    IWViewModel.decimalLimit(jsonResult.precisionObject);

                                    IWViewModel.UpperDecimalLimit(parseInt(IWViewModel.UpperDecimalLimit()).toFixed(IWViewModel.decimalLimit()));
                                    IWViewModel.LowerDecimalLimit(parseInt(IWViewModel.LowerDecimalLimit()).toFixed(IWViewModel.decimalLimit()));

                                    if (jsonResult.TaxonomyLevelChildren.length > 0) {
                                        var mappedTaxonomyLevelChildren = $.map(jsonResult.TaxonomyLevelChildren, (result) => {
                                            return new TaxonomyLevelChildrenModel(result);
                                        });
                                        IWViewModel.TaxonomyLevelChildren([]);
                                        IWViewModel.TaxonomyLevelChildren(mappedTaxonomyLevelChildren);
                                    }

                                    IWViewModel.selectedTaxonomyLevelChild(null);
                                    IWViewModel.selectedTaxonomyLevelChildName(null);
                                    IWViewModel.TaxonomyLevelSelectDisable(false);
                                    for (let i = 0; i < IWViewModel.TaxonomyLevelChildren().length; i++) {
                                        if (IWViewModel.TaxonomyLevelChildren()[i].SelectedFlag() == 1) {
                                            IWViewModel.selectedTaxonomyLevelChild(IWViewModel.TaxonomyLevelChildren()[i].EALId());
                                            IWViewModel.selectedTaxonomyLevelChildName(IWViewModel.TaxonomyLevelChildren()[i].EALName());
                                            IWViewModel.TaxonomyLevelSelectDisable(true);
                                            break;
                                        }
                                    }

                                    if (jsonResult.BUWiseWeightings.length > 0) {
                                        var mappedBusinessUnitData = $.map(jsonResult.BUWiseWeightings, (result) => {
                                            return new BusinessLevelsModel(result);
                                        });
                                        IWViewModel.BusinessUnits([]);
                                        IWViewModel.BusinessUnits(mappedBusinessUnitData);

                                    }

                                    IWViewModel.totalValidityFlag(1);

                                    for (var i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                                        if (IWViewModel.BusinessUnits()[i].total() == IWViewModel.UpperDecimalLimit() || IWViewModel.BusinessUnits()[i].total() == IWViewModel.LowerDecimalLimit()) {
                                            IWViewModel.totalValidityFlag(1);
                                        }
                                        else {
                                            IWViewModel.totalValidityFlag(0);
                                            break;
                                        }
                                    }


                                    IWViewModel.AreasOrQuestions([]);
                                    if (jsonResult.AreaWiseWeightings.length > 0) {
                                        var mappedAreasOrQuestions = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                            return new RiskAreaModel(result);
                                        });
                                        IWViewModel.AreasOrQuestions([]);
                                        IWViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                                    }
                                    setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                    IWViewModel.inherentWeight([]);
                                    if (jsonResult.WeightingsList.length > 0) {
                                        var mappedControlsWeight = $.map(jsonResult.WeightingsList, (result) => {
                                            return new WeightingsModel(result);
                                        });
                                        IWViewModel.inherentWeight([]);
                                        IWViewModel.inherentWeight(mappedControlsWeight);
                                    }


                                    let scrollHeight = "20rem";

                                    if ($.fn.DataTable.isDataTable('#WeightingsTable')) {
                                        IWViewModel.AreasOrQuestions([]);
                                        var tableObj = $('#WeightingsTable').DataTable();
                                        tableObj.fixedHeader.disable();
                                        tableObj.destroy();
                                        $('#WeightingsTable tbody tr').remove();
                                        $("#WeightingsTableHeader > th").remove();
                                        $("#WeightingsTableTotal > th").remove();
                                        var htmlHeader = '';
                                        if (IWViewModel.IsDeadNode() === 1) {
                                            htmlHeader += '<th class="site_name Weightings-Fixed-Column"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'QuesvsBU\') == -1) ? \'Questions ↓ / Business Units →\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'QuesvsBU\')].Name"></span></th> \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ IWViewModel.EditableBusinessUnitName() + '</th>';
                                        }
                                        else {
                                            htmlHeader += '<th class="site_name Weightings-Fixed-Column"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AreasvsBu\') == -1) ? \'Areas ↓ / Business Units →\' : $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf(\'AreasvsBu\')].Name"></span></th> \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ IWViewModel.EditableBusinessUnitName() + '</th>';
                                        }
                                        for (var i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                                            htmlHeader += '<th class="site_name header-ellipsis"><div style="display:flex"><label id=' + IWViewModel.BusinessUnits()[i].BUId() + ' title="' + IWViewModel.BusinessUnits()[i].BUName() + '">' + IWViewModel.BusinessUnits()[i].BUShortName() + '</label> &emsp; <icon class="fa fa-edit float-right float-top" title="Edit Weights" data-bind="click: $root.EditBUWeights"></icon></div></th>';
                                        }

                                        $('#WeightingsTableHeader').html(htmlHeader);
                                        document.getElementById('WeightingsTableHeader').innerHTML = htmlHeader;
                                        ko.cleanNode(document.getElementById('WeightingsTableHeader'));
                                        ko.applyBindings(IWViewModel, document.getElementById("WeightingsTableHeader"));
                                        var htmlFooter = '';
                                        htmlFooter = '<th  class="site_name">Total</th>\
                                        <th class="text-center heatmap-grey" data-bind="css:{\'heatmap-red\' :($root.EditableBusinessunitTotal()!=$root.UpperDecimalLimit()&&$root.EditableBusinessunitTotal()!=0.00),\'heatmap-grey\' : ($root.EditableBusinessunitTotal()==$root.UpperDecimalLimit()||$root.EditableBusinessunitTotal()==$root.LowerDecimalLimit())}"> <span data-bind="text:$root.EditableBusinessunitTotal" > </span> <span> % </span> </th>';
                                        for (i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                                            if (Number(IWViewModel.BusinessUnits()[i].total()).toFixed(IWViewModel.decimalLimit()) != IWViewModel.UpperDecimalLimit() && Number(IWViewModel.BusinessUnits()[i].total()).toFixed(IWViewModel.decimalLimit()) != IWViewModel.LowerDecimalLimit()) {
                                                htmlFooter += '<th class="heatmap-red text-center " >' + IWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                            }
                                            else {
                                                htmlFooter += '<th class="heatmap-grey text-center" >' + IWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                            }

                                        }
                                        $('#WeightingsTableTotal').append(htmlFooter);
                                        document.getElementById('WeightingsTableTotal').innerHTML = htmlFooter;
                                        ko.cleanNode(document.getElementById('WeightingsTableTotal'));
                                        ko.applyBindings(IWViewModel, document.getElementById("WeightingsTableTotal"));

                                        if (jsonResult.AreaWiseWeightings.length > 0) {
                                            var mappedAandQ = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                                return new RiskAreaModel(result);
                                            });

                                            IWViewModel.AreasOrQuestions(mappedAandQ);
                                            setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                        }

                                        tableObj = $('#WeightingsTable').DataTable(
                                            {
                                                'aoColumnDefs': [{
                                                    'bSortable': false,
                                                    "targets": "_all"
                                                }],
                                                "aaSorting": [],
                                                scrollY: scrollHeight,
                                                scrollX: true,
                                                scrollCollapse: true,
                                                paging: false,
                                                "bInfo": false,
                                                "bAutoWidth": false,
                                                fixedColumns: {
                                                    leftColumns: 1
                                                },
                                                fixedheader: {
                                                    header: true
                                                }

                                            }).draw();


                                    }
                                    else if (!$.fn.DataTable.isDataTable('#WeightingsTable')) {
                                        $('#WeightingsTable').DataTable(
                                            {
                                                'aoColumnDefs': [{
                                                    'bSortable': false,
                                                    "targets": "_all"
                                                }],
                                                "aaSorting": [],
                                                scrollY: scrollHeight,
                                                scrollX: true,
                                                scrollCollapse: true,
                                                paging: false,
                                                "bInfo": false,
                                                "bAutoWidth": false,
                                                fixedColumns: {
                                                    leftColumns: 1
                                                },
                                                fixedheader: {
                                                    header: true
                                                }

                                            });
                                    }

                                }
                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() Success method in InherentWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in nodeClickEvent() method in InherentWeightings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function GetQuestionTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetQuestionTypes",
                    type: "GET",
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuestionTypes() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                $('.content').show();
                $('#mainLoader').hide();
                if (jsonResult !== null) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                    else {
                        IWViewModel.QuestionTypes([]);
                        var MappedQuestionTypes = $.map(jsonResult, function (result) {
                            return new QuestionTypeModel(result);
                        });
                        IWViewModel.QuestionTypes(MappedQuestionTypes);
                    }

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionTypes method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionTypes method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSurveyCategoryTabs() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetSurveyCategoryTabsByAssessmentType",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": IWViewModel.AssessmentTypeId(), "ScreenType": "IWX" }
                })
                    .success(function (jsonResult, success) {
                        try {

                            if (jsonResult != null) {
                                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                                }
                                else {
                                    var mappedTabList = $.map(jsonResult, function (result) {
                                        return new SurveyCategoryModel(result);
                                    });
                                    IWViewModel.SurveyCategoryList(mappedTabList);
                                    $('#SurveyCategoryTab_IW').tabs();
                                    $('#SurveyCategoryTab_IW').tabs('refresh');
                                    $('#SurveyCategoryTab_IW').tabs({ active: 0 });
                                    $($('#SurveyCategoryTabsDiv li').get(0)).trigger('click');
                                    scrollableTabs();
                                }
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in InherentWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in InherentWeigthings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in InherentWeigthings.js';
                logger.logMessage(msg);
            }
        }

        function setPrecisionValues(data, event) {
            try {

                try {
                    $.ajax({
                        url: "/api/WeightingsThresholds/setPrecisionValues",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        data: { "DecimalLimit": document.getElementById("precisionDropDown").value }
                    })
                        .success(function (jsonResult, success) {
                            try {
                                if (jsonResult !== null && jsonResult.substring(0, 3) != "INC") {

                                    logger.logSuccess('Precision Values changed successfully.', 'Success', system.getModuleId(IWViewModel), true);
                                    GetInherentWeights();

                                }
                                else {
                                    logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                                }
                            }
                            catch (e) {
                                let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in ControlsWeightings.js';
                                logger.logMessage(msg);
                            }
                        })
                        .fail(function (error, status) {
                            if (error.status === 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then((option) => {
                                        if (option === "OK")
                                            navigation.unauthorized();
                                    });
                            }
                            else {
                                let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in ControlsWeightings.js';
                                logger.logMessage(msg);
                            }

                        });
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setPrecisionValues() method in ControlsWeightings.js';
                logger.logMessage(msg);

            }
        }

        function GetTaxonomyLevels() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetTaxonomyLevel",
                    type: "GET",
                    data: { "SurveyCategoryID": IWViewModel.SurveyCategoryID(), "Show_Lowest_Level": 0 },
                    headers: headers
                };

                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyLevels() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult !== null) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                    else {
                        IWViewModel.TaxonomyLevels([]);
                        var MappedTaxonomyLevel = $.map(jsonResult, function (result) {
                            return new TaxonomyModel(result);
                        });
                        IWViewModel.TaxonomyLevels(MappedTaxonomyLevel);
                    }

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyLevels method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyLevels method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetRiskLevelDetails() {
            try {
                $.ajax({
                    url: "/api/WeightingsThresholds/getAllBusinessUnitLevels",
                    data: { "type": IWViewModel.AssessmentTypeId(), "Page_Type": "W" },
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in InherentWeightings.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null && jsonResult.length > 0) {
                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                        }
                        else {
                            var MappedBUModelList = $.map(jsonResult, (result) => {
                                return new BusinessLevelModel(result);
                            });

                            IWViewModel.BusinessLevelList(MappedBUModelList);


                            $('#RaTab_IW').tabs();
                            $('#RaTab_IW').tabs('refresh');
                            $('#RaTab_IW').tabs({ active: 0 });
                            $($('#RaTab_IW li').get(0)).trigger('click');
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

       //#endregion
        
       //#region ----Set Methods----

        function setSelectedBusinessUnit(id) {
            try {
                for (var i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                    if (IWViewModel.BusinessUnits()[i].BUId() == id) {
                        IWViewModel.SelectBusinessUnit(IWViewModel.BusinessUnits()[i]);
                        break;
                    }
                }
                IWViewModel.EditableBusinessUnitName(IWViewModel.SelectBusinessUnit().BUName());
                IWViewModel.EditableBusinessunitTotal(IWViewModel.SelectBusinessUnit().total());
                for (i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                    IWViewModel.AreasOrQuestions()[i].selectedBuWeight(IWViewModel.SelectBusinessUnit().BUWeightings[i].WeightingValue().toFixed(IWViewModel.decimalLimit()));
                    IWViewModel.AreasOrQuestions()[i].Applicability(IWViewModel.SelectBusinessUnit().BUWeightings[i].Applicability());
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: setSelectedBusinessUnit() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }

        }

        //#endregion

       //#region ----Run Time Methods----

        function SurveyCategoryTabClickIW(data, event) {
            try {

                IWViewModel.SurveyTypeClicked('QLDR');
                IWViewModel.SurveyCategoryID(data.SurveyCategoryId());
                IWViewModel.isAdvancedSettings(data.IsAdvancedSettings());
                IWViewModel.isAdvancedSettingsDUP(data.IsAdvancedSettings());
                //GetTaxonomyLevels();
                GetRiskLevelDetails();
                $('#SurveyCategoryTabsDiv li').removeClass('active');
                $('#ParentTab_' + data.SurveyCategoryId()).addClass('active');

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClickIW() method in AMLWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RiskLevelTabClick(data, event) {
            try {
                $('.content').hide();
                $('#mainLoader').show();
                IWViewModel.ClickedBulevel(data.Bulevel());
                $('#RiskAreaUl li').removeClass('active');
                $('#ChildTab_' + data.Bulevel()).addClass('active');
                IWViewModel.SelectedOrgLevel(data.Bulevel());
                if (data.Bulevel() == "0")
                    IWViewModel.screenType("W");
                else
                    IWViewModel.screenType("OW");
                InitiateLevelTree();
                $("#spanExpandAllIW").text((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                $("#arrowSpanIW").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in RiskLevelTabClick() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

       //#region ----Tree Method----

       function InitiateLevelTree() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {

                    url: "/api/Configuration/GetAllRiskAreasForThreshold",
                    type: "GET",
                    data: { "RiskAreType": IWViewModel.SurveyTypeClicked(), "SurveyCategoryID": IWViewModel.SurveyCategoryID().toString(), "AssessmentTypes": IWViewModel.AssessmentTypeId().toString(), "ScreenType": IWViewModel.screenType() },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in InherentWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {

                $('#mainLoader').hide();
                $('.content').show();

                if (jsonResult !== null) {
                    if (jsonResult.Incident_Description != null) {
                        logger.logError(jsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                    else {

                        IWViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });

                        $('#jsTreeAreaLevel').treeview({
                            data: MappedJsTreeList,
                            onNodeSelected: nodeClickEvent
                        });

                        $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                    }
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes !== undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel === 1)
                            return true;
                        return false;

                    }
                );
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

       function CollapseAllTreeView() {
           if ($('#spanExpandAllIW').text() === ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAllIW").text((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                $("#arrowSpanIW").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAllIW").text((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                $("#arrowSpanIW").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

       //#endregion

       //#region ----Click Events----

        function nodeClickEvent(event, node) {
            try {

                $('#loadingMainInherentDiv').show();
                $('#WeightingsTableDiv').hide();
                IWViewModel.selectedAreaId(node.id);
                IWViewModel.selectedNodeType(node.RA_Type());
                IWViewModel.weightingsTableTitle(node.text);
                IWViewModel.IsDeadNode(node.dead_node);
                GetInherentWeights();

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ModeSettingsClick(data, event) {
            IWViewModel.isAdvancedSettingsDUP(IWViewModel.isAdvancedSettings());
            $('#ModeSelectionSettings').modal('show');
        }

        //#endregion

       //#region ----Configure Precision()----

        function ConfigurePrecision(data, event) {
            try {
                $('#ConfigurePrecisionPopUp').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConfigurePrecision() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

         //#endregion

       //#region ----Copyover----

        function checkCopyOver() {
            app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == 'Confirm') {
                        if (IWViewModel.EditableBusinessunitTotal() != IWViewModel.UpperDecimalLimit()) {
                            logger.logError('The total for weightings should be 100.00000% ', 'Error', system.getModuleId(IWViewModel), true);
                        }
                        else {
                            IWViewModel.WeightingsList([]);
                            app.showMessage("Would you like to copy over same weights to all Business Units?", "Save/Copy Over", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                                .then(function (option) {
                                    if (option == 'Yes') {
                                        for (var j = 0; j < IWViewModel.BusinessUnits().length; j++) {
                                            for (var i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                                                IWViewModel.WeightingsList.push(new WeightingsModel({ BuId: IWViewModel.BusinessUnits()[j].BUId(), RiskAreaId: IWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: IWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                            }
                                        }
                                        saveWeights();
                                    }
                                    else {
                                        for (i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                                            IWViewModel.WeightingsList.push(new WeightingsModel({ BuId: IWViewModel.SelectBusinessUnit().BUId(), RiskAreaId: IWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: IWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                        }
                                        saveWeights();
                                    }
                                });
                        }
                    }
                });
        }

        //#endregion

       //#region ----Toggle Navigate Methods----

        function ToggleNavigationMenu1() {
            var chk2 = $('#NavigationToggle2');
            chk2.prop("checked", false);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#WeightingsTableDiv").toggleClass("col-lg-9 col-lg-12");
            $("#WeightingsTableDiv").toggleClass("col-md-9 col-md-12");
            $("#WeightingsTableDiv").toggleClass("col-sm-9 col-sm-12");
            $("#WeightingsTableDiv").toggleClass("col-xs-9 col-xs-12");
            $("#divNavSwitch2").show();
            $("#divjsTree").hide();
            $("#divExpandSwitch").hide();
        }

        function ToggleNavigationMenu2() {
            var chk1 = $('#NavigationToggle1');
            chk1.prop("checked", true);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#WeightingsTableDiv").toggleClass("col-lg-12 col-lg-9");
            $("#WeightingsTableDiv").toggleClass("col-md-12 col-md-9");
            $("#WeightingsTableDiv").toggleClass("col-sm-12 col-sm-9");
            $("#WeightingsTableDiv").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").hide();
            $("#divjsTree").show();
            $("#divExpandSwitch").show();
        }

        function ToggleSettingsMode(data, event) {
            try {
                app.showMessage("<b> By clicking the Confirm button, Existing weightings will be deleted. If you wish to cancel click on Deny.</b>", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {

                            IWViewModel.isAdvancedSettings(IWViewModel.isAdvancedSettingsDUP());
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/SetAdvanceFlag?AssessmentType=" + IWViewModel.AssessmentTypeId() +
                                    "&SurveyCategoryId=" + IWViewModel.SurveyCategoryID().toString() +
                                    "&AdvanceFlag=" + IWViewModel.isAdvancedSettings(),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json',
                            })
                                .success(ajaxSuccess)
                                .fail(ajaxFail);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in ToggleSettingsMode() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Settings selection saved successfully.', 'Success', system.getModuleId(IWViewModel), true);
                        $('#ModeSelectionSettings').modal('hide');
                        GetSurveyCategoryTabs();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in ToggleSettingsMode() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in ToggleSettingsMode() method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in ToggleSettingsMode() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

       //#region ----Weights Methods----

        function AutoPopulateWeights(data, event) {
            try {
                $('#AutoPopulatePopup').modal('show');
                if (IWViewModel.TaxonomyLevels()== undefined || IWViewModel.TaxonomyLevels().length==0)
                    GetTaxonomyLevels();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: AutoPopulateWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function applyGlobalWeights(data, event) {
            if (IWViewModel.selectedTaxonomyLevelChild())
                $('#ConfirmationGlobalPopup').modal('show');
        }

        function RefreshWeights() {
            try {
                GetInherentWeights();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RefreshWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function EditBUWeights(data, event) {
            try {
                var curr = event.currentTarget.parentElement.children[0].id;
                setSelectedBusinessUnit(curr);
                $("div.dataTables_scrollBody").animate({ scrollLeft: 0 }, 800);

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: EditBUWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function saveWeights() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/SaveInherentWeightings?AssessmentType=" + IWViewModel.AssessmentTypeId() + "&SurveyCategoryId=" + IWViewModel.SurveyCategoryID().toString() + "&AreaId=" + IWViewModel.selectedAreaId() + "&OrgLevel=" + IWViewModel.SelectedOrgLevel() + "&NodeType=" + IWViewModel.selectedNodeType(),//to save the bu level weightings.
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(IWViewModel.WeightingsList(), function (item) {
                        return { BuId: item.BuId(), RiskAreaId: item.RiskAreaId(), WeightingValue: item.WeightingValue() };
                    }))
                })
                    .success(ajaxSuccessInherentWeights)
                    .fail(ajaxFailInherentWeights);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccessInherentWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Inherent Weightings are saved successfully.', 'Success', system.getModuleId(IWViewModel), true);
                        GetInherentWeights();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeights() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailInherentWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeights() method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeights() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PopulateWeights(data, event) {
            try {
                app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {

                            app.showMessage("Populating weights will delete existing configured weights at this level.Are you sure you would like to proceed?", "Warning", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                                .then(function (option) {
                                    if (option == "Yes") {
                                        var OrgLevel = IWViewModel.selectedOrgLevelAP();
                                        var AreaLevel = IWViewModel.selectedTaxonomyLevel();
                                        var QuestionType = $('#QuestionType').val();
                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        $.ajax({
                                            url: "/api/WeightingsThresholds/PopulateInherentWeights?AssessmentType=" + IWViewModel.AssessmentTypeId() + "&SurveyCategoryId=" + IWViewModel.SurveyCategoryID().toString() + "&OrgLevel=" + OrgLevel + "&AreaLevel=" + AreaLevel + "&QuestionType=" + QuestionType,
                                            headers: headers,
                                            type: "POST",
                                            contentType: 'application/json',
                                            dataType: 'json'
                                        })
                                            .success(ajaxSuccessPopulateWeights)
                                            .fail(ajaxFailPopulateWeights);
                                    }

                                });

                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in PopulateWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccessPopulateWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Weightings are populated successfully.', 'Success', system.getModuleId(IWViewModel), true);
                        GetInherentWeights();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in PopulateWeights() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailPopulateWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PopulateWeights() method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in PopulateWeights() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function AdvanceWeightingslevelSelection(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/AdvancedInherentWeightingslevelSelection?AssessmentType=" + IWViewModel.AssessmentTypeId() +
                        "&SurveyCategoryId=" + IWViewModel.SurveyCategoryID().toString() +
                        "&AreaId=" + IWViewModel.selectedAreaId() +
                        "&OrgLevel=" + IWViewModel.SelectedOrgLevel() +
                        "&NodeType=" + IWViewModel.selectedNodeType() +
                        "&GlobalFlag=" + IWViewModel.SaveGlobalFlag() +
                        "&SelectedNewLevel=" + IWViewModel.selectedTaxonomyLevelChild() +
                        "&SelectedNewLevelName=" + IWViewModel.selectedTaxonomyLevelChildName(),
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Configurations are saved successfully.', 'Success', system.getModuleId(IWViewModel), true);
                        $('#ConfirmationGlobalPopup').modal('hide');
                        GetInherentWeights();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightsGlobalFlag() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightsGlobalFlag() method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightsGlobalFlag() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion
       
       //#region ----Upload/Download----

        function uploadDownloadWeightings(data, event) {
            try {
                $('#uploadDownloadWeightingsPopup').modal('show');
                document.getElementById('valfactorerror').innerHTML = "";
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: uploadDownloadWeightings() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BulkDownloadWeights(data, event) {
            try {
                IWViewModel.isGlobalFlag(false);
                $('#BulkDownloadPopup').modal('show');
                if (IWViewModel.TaxonomyLevels() == undefined || IWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
               }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BulkDownloadWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BulkUploadWeights() {
            try {
                $('#uploadBulkWeightingsPopup').modal('show');
                document.getElementById('valfactorerrorbulkupload').innerHTML = "";
                if (IWViewModel.TaxonomyLevels() == undefined || IWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
               }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BulkUploadWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }

        }

        function downloadBulkUploadExcel(data, event) {
            try {
                var selectedOrganizationLevel = $('#OrganizationLevel').val();
                var QuestionType = $('#QuestionTypeBulkUpload').val();

                if (QuestionType == undefined) {
                    QuestionType = "ALL";
                }

                var GlobalFlag = IWViewModel.isGlobalFlag();

                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: data.AssessmentTypeId(), SurveyCategoryId: data.SurveyCategoryID(), AreaId: data.selectedTaxonomyLevel(), OrgLevel: parseInt(selectedOrganizationLevel), Questiontype: QuestionType, isGlobalFlag: GlobalFlag
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadBulkUploadInherentExcelTemplate", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | downloadBulkUploadExcel Source | () in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function uploadWeightingsDocument(data, event) {
            try {
                app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {
                            var FileList = document.getElementById('FileUploader').files;
                            if (FileList.length > 0) {
                                var FileName = document.getElementById('FileUploader').files[0].name;
                                var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase();
                                if (FileExtension == 'XLSX' || FileExtension == 'XLSM') {
                                    if (FileList[0].size <= 1073741824) {
                                        document.getElementById('valfactorerror').innerHTML = "";
                                        var FormDataObj = new FormData();
                                        FormDataObj.append("File1", FileList[0]);
                                        var request = new XMLHttpRequest();

                                        request.onreadystatechange = function () {
                                            if (request.readyState == 1) {
                                                document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                                $('#valfactorerror').show();
                                            }
                                            else if (request.readyState == 4) {
                                                if (request.status == 200) {
                                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                        var DocName = document.getElementById('FileUploader').files[0].name;
                                                        document.getElementById('FileUploader').value = null;
                                                        if (request.responseText == "2" || request.responseText == "-1") {
                                                            document.getElementById('valfactorerror').innerHTML = "Error in file upload";
                                                            logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(IWViewModel), true);
                                                            $('#valfactorerror').show();
                                                        }
                                                        else {

                                                            document.getElementById('valfactorerror').innerHTML = "The file has been uploaded successfully.";
                                                            logger.logSuccess('File Uploaded Successfully', 'Success', system.getModuleId(IWViewModel), true);
                                                            $('#valfactorerror').show();

                                                            GetInherentWeights();

                                                        }
                                                    }
                                                    else {
                                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                                        logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(IWViewModel), true);
                                                        $('#valfactorerror').show();
                                                        document.getElementById('FileUploader').value = null;
                                                    }
                                                }
                                                else
                                                    ajaxFail(request, "");
                                            }
                                        };

                                        request.upload.addEventListener('progress', function (event) {
                                            document.getElementById('valfactorerror').innerHTML = "Uploading File...";
                                        });
                                        request.withCredentials = true;
                                        request.open('POST', "/api/WeightingsThresholds/UploadInherentWeightingsExcelTemplate?matId=" + IWViewModel.selectedAreaId() + "&ratId=" + IWViewModel.AssessmentTypeId() + "&zatId=" + IWViewModel.SurveyCategoryID().toString() + "&OrgLevel=" + IWViewModel.SelectedOrgLevel() + "&NodeType=" + IWViewModel.selectedNodeType());
                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        request.setRequestHeader('Authorization', headers.Authorization);
                                        request.setRequestHeader('RT', headers.RT);
                                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                        request.send(FormDataObj);

                                    }
                                    else {
                                        document.getElementById('FileUploader').value = null;
                                        logger.logError("Upload File Size cannot exceed " + (IWViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.", 'Error', system.getModuleId(IWViewModel), true);
                                    }
                                }
                                else {
                                    document.getElementById('FileUploader').value = null;
                                    logger.logError('Please enter the file in either file in either XLSX or XLSM only.', 'Error', system.getModuleId(IWViewModel), true);
                                }
                            }
                            else {
                                document.getElementById('FileUploader').value = null;
                                logger.logError('Please select a File to Upload', 'Error', system.getModuleId(IWViewModel), true);
                            }
                            function ajaxFail(error, status) {
                                try {
                                    if (error.status == 401) {
                                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                            .then(function (option) {
                                                if (option == "OK")
                                                    router.navigate("survey/SurveyDashBoard", true);
                                            })
                                    }
                                    else {
                                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in uploadWeightingsDocument() method in ControlsWeightings.js';
                                        logger.logMessage(msg);
                                    }
                                } catch (e) {
                                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in uploadWeightingsDocument() method in ControlsWeightings.js';
                                    logger.logMessage(msg);
                                }
                            };
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in uploadWeightingsDocument() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BulkuploadWeightingsDocument(data, event) {
            try {
                app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {
                            var FileList = document.getElementById('FileUploaderBulkUpload').files;
                            if (FileList.length > 0) {
                                var FileName = document.getElementById('FileUploaderBulkUpload').files[0].name;
                                var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase();
                                if (FileExtension == 'XLSX' || FileExtension == 'XLSM') {
                                    if (FileList[0].size <= 1073741824) {
                                        document.getElementById('valfactorerrorbulkupload').innerHTML = "";
                                        var FormDataObj = new FormData();
                                        FormDataObj.append("File1", FileList[0]);
                                        var request = new XMLHttpRequest();

                                        request.onreadystatechange = function () {
                                            if (request.readyState == 1) {
                                                document.getElementById('valfactorerrorbulkupload').innerHTML = "Initializing File Upload...";
                                                $('#valfactorerrorbulkupload').show();
                                            }
                                            else if (request.readyState == 4) {
                                                if (request.status == 200) {
                                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                        var DocName = document.getElementById('FileUploaderBulkUpload').files[0].name;
                                                        document.getElementById('FileUploaderBulkUpload').value = null;
                                                        if (request.responseText == "2" || request.responseText == "-1") {
                                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "Error in file upload";
                                                            logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(IWViewModel), true);
                                                            $('#valfactorerrorbulkupload').show();
                                                        }
                                                        else {

                                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "The file has been uploaded successfully.";
                                                            logger.logSuccess('Sheet uploaded successfully ', 'Success', system.getModuleId(IWViewModel), true);
                                                            $('#valfactorerrorbulkupload').show();

                                                            GetInherentWeights();

                                                        }
                                                    }
                                                    else {
                                                        document.getElementById('valfactorerrorbulkupload').innerHTML = "The file could not be uploaded.";
                                                        logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(IWViewModel), true);
                                                        $('#valfactorerrorbulkupload').show();
                                                        document.getElementById('FileUploader').value = null;
                                                    }
                                                }
                                                else
                                                    ajaxFail(request, "");
                                            }
                                        };

                                        request.upload.addEventListener('progress', function (event) {
                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "Uploading File...";
                                        });
                                        request.withCredentials = true;
                                        request.open('POST', "/api/WeightingsThresholds/UploadInherentBulkWeightingsExcelTemplate?eblid=" + parseInt(IWViewModel.uploadselectedOrganizationLevel()) + "&ratId=" + IWViewModel.AssessmentTypeId() + "&zatId=" + IWViewModel.SurveyCategoryID().toString() + "&ealid=" + IWViewModel.selectedTaxonomyLevel());
                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        request.setRequestHeader('Authorization', headers.Authorization);
                                        request.setRequestHeader('RT', headers.RT);
                                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                        request.send(FormDataObj);

                                    }
                                    else {
                                        document.getElementById('FileUploaderBulkUpload').value = null;
                                        logger.logError("Upload File Size cannot exceed " + (IWViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.", 'Error', system.getModuleId(IWViewModel), true);
                                    }
                                }
                                else {
                                    document.getElementById('FileUploaderBulkUpload').value = null;
                                    logger.logError('Please enter the file in either file in either XLSX or XLSM only.', 'Error', system.getModuleId(IWViewModel), true);
                                }
                            }
                            else {
                                document.getElementById('FileUploaderBulkUpload').value = null;
                                logger.logError('Please select a File to Upload', 'Error', system.getModuleId(IWViewModel), true);
                            }
                            function ajaxFail(error, status) {
                                try {
                                    if (error.status == 401) {
                                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                            .then(function (option) {
                                                if (option == "OK")
                                                    router.navigate("survey/SurveyDashBoard", true);
                                            })
                                    }
                                    else {
                                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in BulkuploadWeightingsDocument() method in InherentWeightings.js';
                                        logger.logMessage(msg);
                                    }
                                } catch (e) {
                                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in BulkuploadWeightingsDocument() method in InherentWeightings.js';
                                    logger.logMessage(msg);
                                }
                            };
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in BulkuploadWeightingsDocument() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function downloadWeightings(data, event) {
            try {

                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: data.AssessmentTypeId(), SurveyCategoryId: data.SurveyCategoryID(), AreaId: data.selectedAreaId(), OrgLevel: data.SelectedOrgLevel(), NodeType: IWViewModel.selectedNodeType()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadExcelInherentWeightings", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | downloadDocuments() in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion        

       //#region ----Models----

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
                self.IsAdvancedSettings = ko.observable(item.IsAdvancedSettings);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.BuLId).text());
                self.BlName = ko.observable($('<div/>').html(item.BuLevelName).text());
                self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
            } catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function TaxonomyModel(item) {
            try {
                var self = this;
                self.LevelId = ko.observable(item.LevelId);
                self.LevelName = ko.observable(item.LevelName);
                self.isMaxLevel = ko.observable(item.isMaxLevel);
                self.showGlobalFlag = ko.observable(item.showGlobalFlag);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function QuestionTypeModel(item) {
            try {
                var self = this;
                self.QuestionType = ko.observable(item.QuestionType);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: QuestionTypeModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.BUId = ko.observable(item.BusinessUnitId);
                self.BUName = ko.observable(item.BusinessUnitName);
                if (item.BusinessUnitName.length > 18) {
                    self.BUShortName = ko.observable((item.BusinessUnitName).substring(0, 15) + '...');
                }
                else
                    self.BUShortName = ko.observable(item.BusinessUnitName);
                if (item.BUWeightings !== undefined && item.BUWeightings !== null) {
                    var MappedWeights = $.map(item.BUWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.BUWeightings = MappedWeights;
                }
                self.total = ko.computed(function () {
                    var total = 0;
                    for (var p = 0; p < self.BUWeightings.length; ++p) {
                        total += Number(Number(self.BUWeightings[p].WeightingValue()));
                    }
                    return total.toFixed(IWViewModel.decimalLimit());
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function TaxonomyLevelChildrenModel(item) {
            try {
                var self = this;
                self.EALId = ko.observable(item.EALId);
                self.EALName = ko.observable(item.EALName);
                self.EALLevel = ko.observable(item.EALLevel);
                self.EALDisplayName = ko.observable(item.EalDisplayName);
                self.SelectedFlag = ko.observable(item.SelectedFlag);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyLevelChildrenModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RiskAreaModel(item) {
            try {
                var self = this;
                if (item.QuestionType == null) {
                    self.QuestionType = '';
                }
                else
                    self.QuestionType = item.QuestionType;
                IWViewModel.isHeaderQuestion(item.QuestionType);
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
                if (item.AreaName.length > 43) {
                    self.AreaShortName = ko.observable((item.AreaName).substring(0, 40) + '...');
                }
                else
                    self.AreaShortName = ko.observable(item.AreaName);
                if (item.AreaWeightings !== undefined && item.AreaWeightings !== null) {
                    var MappedWeights = $.map(item.AreaWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.AreaWeightings = MappedWeights;
                }
                self.selectedBuWeight = ko.observable(0);
                self.selectedBuWeight.subscribe(function (newVal) {
                    if ($.isNumeric(newVal) && Number(newVal) >= Number(IWViewModel.LowerDecimalLimit()) && Number(newVal) <= Number(IWViewModel.UpperDecimalLimit())) {
                        var total = 0;
                        for (var i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                            total += Number(Number(IWViewModel.AreasOrQuestions()[i].selectedBuWeight()));
                        }
                        IWViewModel.EditableBusinessunitTotal(total.toFixed(IWViewModel.decimalLimit()));
                    }
                    else if ($.isNumeric(newVal) && (Number(newVal) < Number(IWViewModel.LowerDecimalLimit()) || Number(newVal) > Number(IWViewModel.UpperDecimalLimit()))) {
                        this.selectedBuWeight(0);
                        logger.logError('Value should be in range of (0-100).', 'Error', system.getModuleId(IWViewModel), true);
                    }
                    else {
                        this.selectedBuWeight(0);
                        logger.logError('Non-numeric values are not allowed.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                }, this);

                self.Applicability = ko.observable(0);
                self.Applicability.subscribe(function (newVal) {
                    this.Applicability(newVal);
                }, this);

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function WeightingsModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable(item.BuId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.WeightingValue = ko.observable(item.WeightingValue);
                self.Applicability = ko.observable(item.Applicability);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WeightingsModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (IWViewModel.AreaLeveljstree()[self.id].length > 0 && item.DeadNode == 0) {
                self.nodes = $.map(IWViewModel.AreaLeveljstree()[self.id], (result) => {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: true };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);

        }

        //#endregion

    });

